/**
 * @generated SignedSource<<76f116ed69ade3567680698b327ad015>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsGroup_creatorGroup$data = {
  readonly creators: ReadonlyArray<{
    readonly name: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly groupName: string | null;
  readonly " $fragmentType": "CreatorsGroup_creatorGroup";
};
export type CreatorsGroup_creatorGroup$key = {
  readonly " $data"?: CreatorsGroup_creatorGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsGroup_creatorGroup">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "vertical"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatorsGroup_creatorGroup",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorFacetType",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "vertical",
              "variableName": "vertical"
            }
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatorGroup",
  "abstractKey": null
};

(node as any).hash = "9b183dc9cd24d62ee59f0fc527ca6bd0";

export default node;
